export default __webpack_public_path__ + "static/media/newclose.f51dfafc.gif";